export default {
  digital: 1,
  connect: 2,
  indicantes: 3,
  one7_mais_credito: 4,
  interno: 5
};
